import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export type ToggleGridProps = HTMLAttributes<HTMLDivElement>;

/**
 * Responsive layout for groups of independent toggle settings.
 * Keeps narrow surfaces linear and caps wider surfaces at two readable columns.
 */
export function ToggleGrid({ className, ...props }: ToggleGridProps) {
  return (
    <div className={cn('grid grid-cols-1 gap-3 md:grid-cols-2', className)} {...props} />
  );
}
